const DEFAULT_FONT_FAMILY = "Arial";

export function normalizeFontFamilyName(value: string | undefined): string {
  if (value === undefined) {
    return DEFAULT_FONT_FAMILY;
  }
  let s = value.trim();
  let changed = true;
  while (changed) {
    changed = false;
    if (s.length >= 2) {
      const first = s[0];
      const last = s[s.length - 1];
      if ((first === '"' && last === '"') || (first === "'" && last === "'")) {
        s = s.slice(1, -1).trim();
        changed = true;
      }
    }
  }
  return s === "" ? DEFAULT_FONT_FAMILY : s;
}
